import React, { useRef } from "react";
import Heading from "../../../components/Heading/Heading";
import UserInput from "../../../components/UserInput/UserInput";
import { withTranslation } from "react-i18next";
import ImportCustoms from "../../AdminDashboard/AdminOrders/PDFs/ImportCustoms";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import axios from "../../../utils/Axios/axiosProxy";
import { PDFInput } from "../../../components/FormInputs/FormInputs";

function ManageImportCustoms({ ...props }) {
  const [data, setData] = React.useState(false);
  const [sent, setSent] = React.useState(false);
  const [error, setError] = React.useState(false);
  const inputRef = useRef(null);
  const downloadPDF = () => {
    const input = document.getElementById("ImportCustoms");
    input.className = "ImportCustoms";
    html2canvas(input, { scale: "2" }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.3);
      let imgWidth = 210;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      const pdf = new jsPDF({ format: "a4" });
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      // pdf.output('dataurlnewwindow');
      pdf.save(`importcustoms${data.orderID ? data.orderID : ""}.pdf`);
    });
    input.className = "ImportCustoms NoDisplay";
  };

  const sendPDF = () => {
    const input = document.getElementById("ImportCustoms");
    input.className = "ImportCustoms";
    html2canvas(input, { scale: "2" }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.3);
      let imgWidth = 210;
      let imgHeight = (canvas.height * imgWidth) / canvas.width;
      let pdf = new jsPDF({ format: "a4" });
      pdf.addImage(
        imgData,
        "JPEG",
        0,
        0,
        imgWidth,
        imgHeight,
        undefined,
        "FAST"
      );
      // pdf.output('dataurlnewwindow');
      pdf = pdf.output("blob");
      sendEmail(pdf, data.orderID, data.email);
    });
    input.className = "ImportCustoms NoDisplay";
  };

  const sendEmail = (data, id, email) => {
    console.log(data);
    let formData = new FormData();
    formData.append("pdf", data);
    formData.append("orderID", id);
    formData.append("email", email);
    console.log(formData);
    axios
      .post("/api/communication/email", formData, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        setSent(true);
        setError(false);
        console.log("SEND PDF RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("SEND PDF ERROR: ", error);
        setError(true);
      })
      .catch((error) => console.log("SEND PDF CLIENT ERROR", error));
  };
  const importCustomsInputs = [
    {
      label: <span>Shipment Nr.</span>,
      id: "orderID",
    },
    {
      label: <span>Email</span>,
      id: "email",
    },
    {
      label: (
        <span>
          Shipper |<span style={{ fontStyle: "italic" }}> Feladó:</span>
        </span>
      ),
      id: "shipper",
    },
    {
      label: (
        <span>
          Address |<span style={{ fontStyle: "italic" }}> Cím:</span>
        </span>
      ),
      id: "addressshipper",
    },
    {
      label: (
        <span>
          (VPID) EORI number |
          <span style={{ fontStyle: "italic" }}> EORI szám:</span>
        </span>
      ),
      id: "eori",
    },
    {
      label: (
        <span>
          EU VAT ID | <span style={{ fontStyle: "italic" }}> EU adószám:</span>
        </span>
      ),
      id: "euvat",
    },
    {
      label: (
        <span>
          Bankaccount-No |
          <span style={{ fontStyle: "italic" }}> Bankszámlaszám:</span>
        </span>
      ),
      id: "bankaccount",
    },
    {
      label: (
        <span>
          IBAN-No |<span style={{ fontStyle: "italic" }}> Iban szám:</span>
        </span>
      ),
      id: "bankaccount",
    },
    {
      label: (
        <span>
          Consignee |<span style={{ fontStyle: "italic" }}> Címzett:</span>
        </span>
      ),
      id: "consignee",
    },
    {
      label: (
        <span>
          Address |<span style={{ fontStyle: "italic" }}> Cím: </span>
        </span>
      ),
      id: "addressconsignee",
    },
    {
      label: (
        <span>
          Phone/FAX |<span style={{ fontStyle: "italic" }}> Telefon-fax:</span>
        </span>
      ),
      id: "phone",
    },
    {
      label: (
        <span>
          Description of the goods |
          <span style={{ fontStyle: "italic" }}> Árumegnevezés:</span>
        </span>
      ),
      id: "shipmentdescr",
    },
    {
      label: (
        <span>
          Customs tarif. |
          <span style={{ fontStyle: "italic" }}> Tarifa szám:</span>
        </span>
      ),
      id: "tarifnr",
    },
    {
      label: (
        <span>
          Cargo value |<span style={{ fontStyle: "italic" }}> Áruérték:</span>
        </span>
      ),
      id: "cargovalue",
    },
    {
      label: (
        <span>
          Colli |<span style={{ fontStyle: "italic" }}> Colli szám:</span>
        </span>
      ),
      id: "collinr",
    },
    {
      label: (
        <span>
          Incoterms |<span style={{ fontStyle: "italic" }}> Fuvarparitás:</span>
        </span>
      ),
      id: "incoterms",
    },
    {
      label: (
        <span>
          Gross weight |
          <span style={{ fontStyle: "italic" }}> Bruttó súly:</span>
        </span>
      ),
      id: "grossweight",
    },
  ];
  const radioInputs = [
    { label: "Határozatra fizetés", id: "id1" },
    { label: "Halasztott engedély", id: "id2" },
    { label: "Vámletét számlára történő fizetés", id: "id3" },
    { label: "Önadózási engedély", id: "id4" },
    { label: "Áfa biztosítása alóli mentesség", id: "id5" },
    {
      label:
        "Import engedély | Növényeü.-i igazolvány | Állat eü-i igazolvány | Márkavédelmi engedély",
      id: "6",
    },
  ];
  const handleChange = (event) => {
    setData({ ...data, [event.target.id]: event.target.value });
  };
  return (
    <>
      <p
        className="ProfileText"
        style={{
          textAlign: "center",
          fontSize: "36px",
          width: "90%",
          textShadow: "2px 2px #ff0000",
        }}
      >
        Welcome, please fill out the following form with your details, and click
        on Send!
      </p>
      <div className="DashboardContent BoxShadow" style={{ padding: 0 }}>
        <Heading
          title="Import Customs Clearance"
          className="ToreaBay Small"
          classNameNr2={sent ? "Confirmed Small" : "ToreaBay Small"}
          button
          buttonNr2
          disabled={sent ? true : false}
          titleB2={sent ? "Sent" : "Send"}
          titleB="Download"
          onClick={() => {
            downloadPDF();
          }}
          onClick2={() => {
            sendPDF();
          }}
        />
        <div className="UserInfoContainer">
          {error ? (
            <p
              className="WelcomeText"
              style={{
                fontSize: "26px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              There's been an error while trying to send the document, please
              try again!
            </p>
          ) : null}
          {sent ? (
            <p
              className="WelcomeText"
              style={{
                fontSize: "26px",
                textAlign: "center",
                fontWeight: "bold",
              }}
            >
              Thank you for submitting Order for import customs clearance for
              direct representation
            </p>
          ) : null}
          {importCustomsInputs.map((item, i) => {
            return (
              <UserInput
                key={i}
                name={item.label}
                id={item.id}
                labelStyle={{ width: "500px" }}
                value={data[item.id]}
                onChange={(event) => handleChange(event)}
              />
            );
          })}
          <div
            className="ImportCustomsContent"
            style={{ width: "100%", marginLeft: "0" }}
          >
            <p style={{ fontSize: "16px", marginBottom: "16px" }}>
              Mode of customs clearance |
              <span style={{ fontStyle: "italic" }}>Vámkezelés módja </span>(A
              kívánt eljárást kérjük megjelölni szíveskedjen):
            </p>
            <input
              type="checkbox"
              style={{ marginBottom: "16px" }}
              checked={data.checkbox1}
              onChange={(event) =>
                setData({ ...data, checkbox1: event.target.checked })
              }
            />
            <span>Szabadforgalomba helyezés</span>
            <br />
            {radioInputs.map((input) => {
              return (
                <>
                  <div style={{ display: "flex", flexDirection: "row" }}>
                    <input
                      type="radio"
                      id={input.id}
                      onClick={(event) => {
                        console.log(event.target.checked);
                        data[event.target.id] !== undefined
                          ? setData({
                              ...data,
                              [event.target.id]: !data[event.target.id],
                            })
                          : setData({
                              ...data,
                              [event.target.id]: event.target.checked,
                            });
                      }}
                      checked={data[input.id]}
                      style={{ marginLeft: "16px" }}
                    />
                    <div>{input.label}</div>
                    {input.id === "id2" || input.id === "id4" ? (
                      <div>
                        <PDFInput
                          value={data[`${input.id}text`]}
                          inputStyle={{ marginBottom: "2px", width: "20%" }}
                          labelStyle={{
                            padding: "0 0 2px 0",
                            fontSize: "16px",
                          }}
                          label="(száma"
                          onChange={(event) =>
                            setData({
                              ...data,
                              [`${input.id}text`]: event.target.value,
                            })
                          }
                        />
                      </div>
                    ) : null}
                  </div>
                  <br />
                </>
              );
            })}
            <div className="Row" style={{ position: "relative" }}>
              <input
                type="checkbox"
                checked={data.checkbox2}
                onChange={(event) =>
                  setData({ ...data, checkbox2: event.target.checked })
                }
              />
              <span>Árutovábbítás</span>
              <PDFInput
                value={data.forward}
                inputStyle={{ marginBottom: "2px", width: "20%" }}
                labelStyle={{
                  padding: "0 0 2px 0",
                  fontSize: "16px",
                }}
                label=" "
                onChange={(event) =>
                  setData({
                    ...data,
                    forward: event.target.value,
                  })
                }
              />
              <div style={{ position: "absolute", left: "340px" }}>
                Vámhivatalhoz
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="FlexCenter">
            <div
              id="ImportCustoms"
              className="ImportCustoms NoDisplay" //NoDisplay
              ref={inputRef}
              style={{ width: "792px" }}
            >
              <ImportCustoms data={data} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default withTranslation()(ManageImportCustoms);
